import {
    AppModule,
    availableCompanyActions,
    availableModules,
    availableReportsActions,
    availableUsersTrackingActions,
    IModuleInfo,
    ModuleAction,
} from '@/types/module';

export class ModuleUtils {
    public static findModuleByPath(path: string): AppModule | undefined {
        if (path === '/') {
            return 'home';
        }

        const modules = availableModules
            .filter((x) => {
                return x !== 'home';
            })
            .map(this.getModuleInfo);

        return modules.find((x) => {
            return path.startsWith(x.path);
        })?.module;
    }

    public static getActionName(action: ModuleAction): string {
        switch (action) {
            case 'details':
                return 'Detalles';

            case 'update':
                return 'Actualizar';

            case 'delete':
                return 'Eliminar';

            case 'list':
                return 'Listar';

            case 'create':
                return 'Crear';

            case 'disable':
                return 'Deshabilitar';

            case 'enable':
                return 'Habilitar';

            case 'changeStatus':
                return 'Cambiar estado(Agentes)';

            case 'changeStatusAdmin':
                return 'Cambiar estado(Supervisor)';
            case 'detailsAdmin':
                return 'Ver detalles(Supervisor)';
            case 'assignMe':
                return 'Asignarme a mi';
            case 'transferTicket':
                return 'Transferir ticket';
            case 'unAssignTicket':
                return 'Eliminar Asignación';


            case 'user_change_state':
            case 'users_tracking_change_state':
                return 'Cambiar Estado';

            case 'reports_tickets_billing':
                return 'Reporte Control de Liquidación';


            case 'company_custom_fields_add':
                return 'Agregar Campo Personalizado';
            case 'company_custom_fields_edit':
                return 'Editar Campo Personalizado';
            case 'company_custom_fields_delete':
                return 'Eliminar Campo Personalizado';

            case 'company_types_add':
                return 'Agregar Tipo';
            case 'company_types_edit':
                return 'Editar Tipo';
            case 'company_types_delete':
                return 'Eliminar Tipos';

            case 'company_tags_add':
                return 'Agregar Etiqueta';
            case 'company_tags_edit':
                return 'Editar Etiqueta';
            case 'company_tags_delete':
                return 'Eliminar Etiquetas';

            case 'company_ticket_states_bot_config':
                return 'Configuración de Estados de Bots';
            case 'company_ticket_states_operators_config':
                return 'Configuración de Estados de Operadores';

            case 'company_chatbot_add':
                return 'Agregar Chat Bot';
            case 'company_chatbot_details':
                return 'Detalles de Chat Bot';
            case 'company_chatbot_edit':
                return 'Editar Chat Bot';
            case 'company_chatbot_import':
                return 'Importar Chat Bot';
            case 'company_chatbot_export':
                return 'Exportar Chat Bot';
            case 'company_chatbot_test':
                return 'Probar Chat Bot';
            case 'company_chatbot_remove':
                return 'Eliminar Chat Bot';

            case 'company_chatbot_mono_general_data_tab_hidden':
                 return 'Ocultar en Chatbot Mono Agente Datos  Generales'
            case 'company_chatbot_mono_prompt_tab_hidden':
                 return 'Ocultar en Chatbot Mono Agente Prompt'
            case 'company_chatbot_mono_rag_tab_hidden':
                 return 'Ocultar en Chatbot Mono Agente Saludo'
            case 'company_chatbot_mono_derivation_tab_hidden':
                 return 'Ocultar en Chatbot Mono Agente Derivación'
            case 'company_chatbot_mono_tools_tab_hidden':
                 return 'Ocultar en Chatbot Mono Agente Tools'
            case 'company_chatbot_mono_ktags_tab_hidden':
                 return 'Ocultar en Chatbot Mono Agente Ktags'

            case 'company_chatbot_multi_general_data_tab_hidden':
                 return 'Ocultar en Chatbot Multi Agente Datos Generales'
            case 'company_chatbot_multi_prompt_tab_hidden':
                 return 'Ocultar en Chatbot Multi Agente Prompt'
            case 'company_chatbot_multi_assistant_tab_hidden':
                 return 'Ocultar en Chatbot Multi Agente Asistente'





            case 'company_integration_add':
                return 'Agregar Integración';
            case 'company_integration_details':
                return 'Detalles de Integración';
            case 'company_integration_edit':
                return 'Editar Integración';
            case 'company_integration_remove':
                return 'Eliminar Integración';

            case 'company_templates_add':
                return 'Adicionar Plantilla';
            case 'company_templates_details':
                return 'Detalles de Plantilla';
            case 'company_templates_edit':
                return 'Editar Plantilla';
            case 'company_templates_remove':
                return 'Eliminar Plantilla';

            case 'company_campaigns_details':
                return 'Detalles de Campañas';
            case 'company_campaigns_add':
                return 'Agregar Campañas';
            case 'company_campaigns_edit':
                return 'Editar Campañas';
            case 'company_campaigns_remove':
                return 'Eliminar Campañas';
            case 'company_campaigns_stats':
                return 'Estadísticas de Campañas';
            case 'company_campaigns_report':
                return 'Reporte de Campañas';

            case 'company_automations_add':
                return 'Agregar Automatización';
            case 'company_automations_details':
                return 'Detalles de Automatización';
            case 'company_automations_edit':
                return 'Editar Automatización';
            case 'company_automations_remove':
                return 'Eliminar Automatización';

            case 'company_custom_responses_add':
                return 'Agregar Respuesta Personalizada';
            case 'company_custom_responses_details':
                return 'Detalles de Respuesta Personalizada';
            case 'company_custom_responses_edit':
                return 'Editar Respuesta Personalizada';
            case 'company_custom_responses_remove':
                return 'Eliminar Respuesta Personalizada';

            /*
        case 'chatbotDetails':
            return 'Detalles de chatbots';

        case 'chatbotAdd':
            return 'Agregar chatbot';

        case 'chatbotEdit':
            return 'Editar chatbot';

        case 'chatbotDelete':
            return 'Eliminar chatbot';

        case 'chatbotChangeStatus':
            return 'Cambiar estado de chatbot';
        */
            default: {
                return String(action);
            }
        }
    }

    public static getModuleInfo(module: AppModule): IModuleInfo {
        switch (module) {
            case 'home':
                return {
                    label: 'Dashboard',
                    path: '/',
                    module,
                    availableActions: [],
                };

            case 'users':
                return {
                    label: 'Lista de Usuarios',
                    path: '/users',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'companies':
                return {
                    label: 'Empresas',
                    path: '/companies',
                    module,
                    availableActions: ['details', ...availableCompanyActions],
                };

            case 'groups':
                return {
                    label: 'Grupos de Atención',
                    path: '/groups',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'tags':
                return {
                    label: 'Etiquetas',
                    path: '/tags',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'types':
                return {
                    label: 'Tipificaciones',
                    path: '/types',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'roles':
                return {
                    label: 'Roles y Permisos',
                    path: '/roles',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'tickets':
                return {
                    label: 'Tickets',
                    path: '/tickets/',
                    module,
                    availableActions: [
                        'create',
                        'details',
                        'delete',
                        'update',
                        'changeStatus',
                        'changeStatusAdmin',
                        'detailsAdmin',
                        'assignMe',
                        'transferTicket',
                        'unAssignTicket',
                    ],
                };

            case 'channels':
                return {
                    label: 'Canales',
                    path: '/channels',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'contacts':
                return {
                    label: 'Contactos',
                    path: '/contacts',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };
            // case 'bots':
            //     return {
            //         label: 'Asistente IA',
            //         path: '/bots',
            //         module,
            //         availableActions: ['create', 'details', 'delete', 'update'],
            //     };
            case 'reports':
                return {
                    label: 'Reportes',
                    path: '/reports',
                    module,
                    availableActions: ['details', ...availableReportsActions],
                };
            case 'customFields':
                return {
                    label: 'Campos',
                    path: '/customFields',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'templates':
                return {
                    label: 'Plantillas',
                    path: '/templates',
                    module,
                    availableActions: ['create', 'details', 'delete', 'update'],
                };

            case 'tools':
                return {
                    label: 'Gestor de Tools',
                    path: '/tools',
                    module,
                    availableActions: ['create', 'delete', 'update', 'details'],
                };
            case 'records':
                return {
                    label: 'Registro de Costos',
                    path: '/records',
                    module,
                    availableActions: ['create', 'delete', 'update', 'details'],
                };

            case 'ia-tester':
                return {
                    label: 'Prueba de Bot',
                    path: '/ia-tester',
                    module,
                    availableActions: [],
                };

            case 'users-tracking':
                return {
                    label: 'Seguimiento de Usuarios',
                    path: '/users-tracking',
                    module,
                    availableActions: ['details', ...availableUsersTrackingActions],
                };

            case 'monitoring':
                return {
                    label: 'Monitoreo',
                    path: '/monitoring',
                    module,
                    availableActions: ['details'],
                };

            case 'interactions':
                return {
                    label: 'Interacciones',
                    path: '/interactions',
                    module,
                    availableActions: ['details'],
                };

            default: {
                return {
                    label: `--${module}`,
                    path: '/404',
                    module,
                    availableActions: [],
                };
            }
        }
    }
}
